import { render, staticRenderFns } from "./milestones.vue?vue&type=template&id=d49f6688&scoped=true"
import script from "./milestones.vue?vue&type=script&lang=js"
export * from "./milestones.vue?vue&type=script&lang=js"
import style0 from "./milestones.vue?vue&type=style&index=0&id=d49f6688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f6688",
  null
  
)

export default component.exports